import { TreeAdapter } from ".";

export type JobRunOutcome = {
    id: number;
    text: string;
    icon?: string;
    color?: string;
}

export enum JobRunOutcomeId {
    Failed = 0,
    Succeeded = 1,
    Retry = 2,
    Canceled = 3,
    InProgress = 4,
    Unknown = 5
}

export const JOB_RUN_OUTCOMES: readonly JobRunOutcome[] = [
    { id: JobRunOutcomeId.Failed, text: 'Failed', icon: 'circle-exclamation', color: '#c60404ff' },
    { id: JobRunOutcomeId.Succeeded, text: 'Succeeded', icon: 'circle-check', color: '#0f7102ff' },
    { id: JobRunOutcomeId.Retry, text: 'Retry', icon: 'circle-notch', color: '#b78702ff' },
    { id: JobRunOutcomeId.Canceled, text: 'Canceled', icon: 'circle-xmark' },
    { id: JobRunOutcomeId.InProgress, text: 'In Progress', icon: 'circle-info' },
    { id: JobRunOutcomeId.Unknown, text: 'Unknown', icon: 'circle-question' },
] as const;

export const JOB_RUN_OUTCOME_MAP = new Map<JobRunOutcomeId, JobRunOutcome>(
    JOB_RUN_OUTCOMES.map(o => [o.id as JobRunOutcomeId, o])
);

export const WEEK_DAYS: { day: number; name: string }[] = [
    { day: 1, name: 'Monday' },
    { day: 2, name: 'Tuesday' },
    { day: 3, name: 'Wednesday' },
    { day: 4, name: 'Thursday' },
    { day: 5, name: 'Friday' },
    { day: 6, name: 'Saturday' },
    { day: 7, name: 'Sunday' },
];